import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button from './Button';

class Select extends React.Component {

  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.resolveState(props));
  }

  resolveState(props) {
    return {
      selected: props.selectedChoice,
      choices: props.choices,
    };
  }

  componentDidMount() {
    if (this.state.selected) { this.props.onSelection(this.state.selected); }
  }

  render () {
    const { submitting, className } = this.props;
    const { selected, choices } = this.state;

    const buttonClass = (choices.length % 2 == 1) ? 'three-column' : '';

    return (
      <div className={cx('button-select', className)}>
        { this.state.choices.map((choice) =>
          <Button
            className={cx('questionnaire__button', buttonClass)}
            label={choice.label}
            key={choice.id}
            selected={(selected == choice.id)}
            onClick={this.onAnswer.bind(this, choice.id)}
            showSpinner={submitting && (choice.id === selected)}
          />
        )}
      </div>
    );
  }

  onAnswer(choice) {
    if (this.props.submitting) { return; }

    this.setState({ selected: choice }, () => {
      this.props.onSelection(choice);
    });
  }

}

Select.defaultProps = {
  className: '',
  submitting: false
};

Select.propTypes = {
  className: PropTypes.string,
  choices: PropTypes.array.isRequired,
  selectedChoice: PropTypes.string,
  onSelection: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

export default Select;
